var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCheckbox(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M19.9991 30.3337H11.9991C4.7591 30.3337 1.66577 27.2403 1.66577 20.0003V12.0003C1.66577 4.76033 4.7591 1.66699 11.9991 1.66699H19.9991C27.2391 1.66699 30.3324 4.76033 30.3324 12.0003V20.0003C30.3324 27.2403 27.2391 30.3337 19.9991 30.3337ZM11.9991 3.66699C5.85244 3.66699 3.66577 5.85366 3.66577 12.0003V20.0003C3.66577 26.147 5.85244 28.3337 11.9991 28.3337H19.9991C26.1458 28.3337 28.3324 26.147 28.3324 20.0003V12.0003C28.3324 5.85366 26.1458 3.66699 19.9991 3.66699H11.9991Z",
    fill: "#3D48E5"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M14.1057 20.7735C13.839 20.7735 13.5857 20.6668 13.399 20.4801L9.62569 16.7068C9.23903 16.3201 9.23903 15.6801 9.62569 15.2935C10.0124 14.9068 10.6524 14.9068 11.039 15.2935L14.1057 18.3601L20.959 11.5068C21.3457 11.1201 21.9857 11.1201 22.3724 11.5068C22.759 11.8935 22.759 12.5335 22.3724 12.9201L14.8124 20.4801C14.6257 20.6668 14.3724 20.7735 14.1057 20.7735Z",
    fill: "#3D48E5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCheckbox);
export default __webpack_public_path__ + "static/media/checkbox.d6d3f519154a21225c8ed788407231be.svg";
export { ForwardRef as ReactComponent };